import { API_ENDPOINT } from '../../../constants';
import { fetchWrapper } from '../../../helpers';

import type { GetAccessTokenSilently, IProvider } from '../../../utils/types';
import type { ProviderSsnResponse } from './types';

export async function fetchProviderSsn(
  providerId: number,
  getAccessTokenSilently: GetAccessTokenSilently,
  signal?: AbortSignal,
): Promise<ProviderSsnResponse> {
  return fetchWrapper.get({
    url: `${API_ENDPOINT}/providers/${providerId}/ssn`,
    getAccessTokenSilently,
    signal,
  });
}

export async function updateProviderSsn(
  providerId: number,
  ssn: string,
  getAccessTokenSilently: GetAccessTokenSilently,
): Promise<ProviderSsnResponse> {
  return fetchWrapper.put(
    {
      url: `${API_ENDPOINT}/providers/${providerId}/ssn`,
      getAccessTokenSilently,
    },
    { ssn },
  );
}

export async function revealProviderSsn(
  providerId: number,
  password: string,
  getAccessTokenSilently: GetAccessTokenSilently,
): Promise<ProviderSsnResponse> {
  return fetchWrapper.post(
    {
      url: `${API_ENDPOINT}/providers/${providerId}/ssn/reveal`,
      getAccessTokenSilently,
    },
    { password },
  );
}

export async function fetchProviderById(
  providerId: number | string,
  getAccessTokenSilently: GetAccessTokenSilently,
  signal?: AbortSignal,
): Promise<IProvider> {
  return fetchWrapper.get({
    url: `${API_ENDPOINT}/providers/${providerId}/?include_roles=true`,
    getAccessTokenSilently,
    signal,
  });
}

export async function updateProviderReviewerBcba(
  providerId: number,
  active: boolean,
  password: string,
  getAccessTokenSilently: GetAccessTokenSilently,
): Promise<IProvider> {
  return fetchWrapper.put(
    { url: `${API_ENDPOINT}/providers/${providerId}/reviewer_bcba/`, getAccessTokenSilently },
    { active, password },
  );
}
